import { QueryFormatterFactory } from '~/modules/queryFormatters/QueryFormatterFactory'

export default function useFilters({
  contentType,
  componentType,
}: { contentType?: Ref<string>; componentType?: Ref<string> } = {}) {
  const route = useRoute()
  const queryFormatter = QueryFormatterFactory(componentType?.value)

  const hasFilterBar = computed(() =>
    filteredTypes.includes(contentType?.value)
  )
  const filterQuery = computed(() => {
    return queryFormatter.getFilterQuery(route.query)
  })
  const isFiltered = computed(() => !!Object.keys(filterQuery.value).length)
  const sortByQuery = computed(() => queryFormatter.getSortQuery(route.query))

  return {
    hasFilterBar,
    isFiltered,
    filterQuery,
    sortByQuery,
  }
}
